import { render, staticRenderFns } from "./TargetGroupCampaignModal.vue?vue&type=template&id=000d5c52&scoped=true&"
import script from "./TargetGroupCampaignModal.vue?vue&type=script&lang=js&"
export * from "./TargetGroupCampaignModal.vue?vue&type=script&lang=js&"
import style0 from "./TargetGroupCampaignModal.vue?vue&type=style&index=0&id=000d5c52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000d5c52",
  null
  
)

export default component.exports